import React from 'react';
import { Circle } from '@phosphor-icons/react';

export function EditCount({ count }: { count: number }) {
  return (
    <span className="inline-flex items-center gap-0.5">
      <Circle size={8} weight="fill" aria-hidden="true" className="text-blue" />
      <span className="text-xs leading-4 text-subtle">
        {count} {count === 1 ? 'edit' : 'edits'}
      </span>
    </span>
  );
}
